<script setup lang="ts">
import AutoPostList from '~/components/AutoPostList.vue'

definePageMeta({
  middleware: () => {
    const { Settings } = useSettings()
    if (!Settings.value.enableSearch) return navigateTo('/')
    return
  }
})

const route = useRoute()
const searchQuery = ref(route.query.query?.toString()) // that's what the user is typing
const submittedQuery = ref<string>(route.query.query?.toString()) // that's the last thing the user submitted

async function onSubmit() {
  if(searchQuery.value) {
    navigateTo({query: { query: searchQuery.value }})
    submittedQuery.value = searchQuery.value
    document.querySelector('form  input')?.blur()
  }
}

function searchApi() {
  const params = new URLSearchParams({query: submittedQuery.value ?? ""})
  const url = `/api/post/search?${params}`
  console.log("Search API URL:", url)
  return url
}

</script>

<template>
  <div>
    <h2>{{$t('Search')}}</h2>
    <v-form @submit.prevent="onSubmit">
      <v-text-field v-model.trim="searchQuery" :placeholder="$t('Search')" variant="outlined" hide-details single-line
        autofocus append-inner-icon="mdi-magnify" class="text-black"
        @click:append-inner="onSubmit"
        type="search" 
       />
    </v-form>
    <AutoPostList
      :api="searchApi()"
      :key="searchApi()"   
      offset-pagination
    />
  </div>
</template>
